// extracted by mini-css-extract-plugin
export default {"container":"popup_container__bx+Nt","popup":"popup_popup__FuubS","overflow":"popup_overflow__MyWd7"};